import styled from "styled-components";

export const TierLevelPointsStyled = styled.div`
  border-top: 1px solid #C8C8C8;
  border-bottom: 1px solid #C8C8C8;
  position: relative;
  padding-left: 50%;
  padding-right: 8px;
  margin-top: 20px;
  padding-top: 12px;
  padding-bottom: 20px;
  p {
    font-size: 13px;
    text-align: center;
    margin-top: 0;
  }

  > span {
    font-weight: bold;
    display: block;
    text-align: center;
    font-size: 11px;
    text-transform: uppercase;
  }
`;

export const TierCircleWrapper = styled.div`
  background: white;
  width: 186px;
  height: 186px;
  border: 7px solid white;
  position: absolute;
  top: -18px;
  left: 0;
  border-radius: 50%;
`;

export const BasicTierCircleStyled = styled.div<{ color: string }>`
  width: 172px;
  height: 172px;
  border: 7px solid ${p => p.color};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  span {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 400;
    font-family: 'Bowlby One';
    color: ${p => p.color};
  }
`;

export const FlameListStyled = styled.div`
  text-align: center;
  svg {
    display: inline-block;
    width: 20px;
    height: auto;
    margin: 0 4px;
  }
`;